module.exports = __webpack_public_path__ + "static/img/01.73797ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/01.jpg
// module id = T1au
// module chunks = 0